export default __webpack_public_path__ + "static/media/dialerreports.9387cbdb.svg";